import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = { isLoading: false, data: {}, errors: [] };

export const getComments = createAsyncThunk('comments/getComments', async (args, thunkApi) => {
  try {
    const { page = 1, size = 10, serverId = '' } = args || {};
    const { data } = await axios.get(`/api/get_comments?page=${page}&size=${size}&serverId=${serverId}`);
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const createComment = createAsyncThunk('comments/createComment', async (args, thunkApi) => {
  try {
    const { data } = await axios.post('/api/create_comment', args, {
      headers: { 'Content-Type': 'application/json' }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const likeComment = createAsyncThunk('comments/likeComment', async (args, thunkApi) => {
  try {
    const { data } = await axios.put(`/api/like_comment/${args._id}`);
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue({ errors: [{ msg: 'something went wrong' }] });
  }
});

export const deleteComment = createAsyncThunk('comments/deleteComment', async (args, thunkApi) => {
  try {
    const { data } = await axios.delete(`/api/delete_comment/${args._id}`, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  extraReducers: {
    [getComments.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [getComments.fulfilled]: (state, action) => { state.isLoading = false; state.data = action.payload; },
    [getComments.rejected]: (state, action) => { state.isLoading = false; state.data = {}; state.errors = action.payload.errors; },

    [createComment.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [createComment.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.itemsCount = (state.data.itemsCount || 0) + 1;
      state.data.data = [action.payload.data, ...(state.data.data || [])];
    },
    [createComment.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [likeComment.fulfilled]: (state, action) => {
      const idx = state.data.data?.findIndex(el => el._id === action.payload.data._id);
      if (idx !== undefined && idx >= 0) state.data.data[idx] = action.payload.data;
    },

    [deleteComment.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [deleteComment.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.data = state.data.data?.filter(el => el._id !== action.payload.data._id);
      state.data.itemsCount = Math.max(0, (state.data.itemsCount || 1) - 1);
    },
    [deleteComment.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },
  }
});

export default commentsSlice.reducer;
